// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._19VPWNoGutZoPI {\n  padding: 0 12px;\n  word-break: break-word;\n}\n._19VPWNoGutZoPI p {\n  margin: 0 0 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmContainer": "_19VPWNoGutZoPI"
};
export default ___CSS_LOADER_EXPORT___;
